import type { CatalogStatusFilter } from './CatalogToolbar';

/**
 * Apply the shared search + status filter to a catalog list.
 * `getText` returns the searchable strings for an item (name, category, id…).
 */
export function filterCatalog<T>(
  items: T[],
  search: string,
  statusFilter: CatalogStatusFilter,
  getText: (item: T) => Array<string | undefined>,
  isActive: (item: T) => boolean
): T[] {
  const q = search.trim().toLowerCase();
  return items.filter(item => {
    if (statusFilter === 'active' && !isActive(item)) return false;
    if (statusFilter === 'inactive' && isActive(item)) return false;
    if (!q) return true;
    return getText(item).some(t => t?.toLowerCase().includes(q));
  });
}
